/// <reference types="./combobox.d.mts" />
import * as $unsafe from "../../../common_common/gleam/unsafe.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $function from "../../../gleam_stdlib/gleam/function.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $justin from "../../../justin/justin.mjs";
import * as $lustre from "../../../lustre/lustre.mjs";
import * as $a from "../../../lustre/lustre/attribute.mjs";
import * as $component from "../../../lustre/lustre/component.mjs";
import * as $eff from "../../../lustre/lustre/effect.mjs";
import * as $el from "../../../lustre/lustre/element.mjs";
import * as $html from "../../../lustre/lustre/element/html.mjs";
import * as $e from "../../../lustre/lustre/event.mjs";
import * as $sketch from "../../../sketch/sketch.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import * as $sl from "../../../sketch_lustre/sketch/lustre.mjs";
import * as $h from "../../../sketch_lustre/sketch/lustre/element/html.mjs";
import * as $input from "../../ds/components/input.mjs";
import * as $portal from "../../ds/components/portal.mjs";
import * as $cy from "../../ds/cypress.mjs";
import * as $effects from "../../ds/effects.mjs";
import * as $icons from "../../ds/icons.mjs";
import * as $position from "../../ds/internals/position.mjs";
import * as $s from "../../ds/internals/styles/dropdown.mjs";
import * as $utils from "../../ds/utils.mjs";
import {
  Ok,
  Error,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
  isEqual,
} from "../../gleam.mjs";
import * as $window from "../../web/browser/window.mjs";

const FILEPATH = "src/ds/components/combobox.gleam";

class NoChoice extends $CustomType {}

class Section extends $CustomType {
  constructor(title, class$) {
    super();
    this.title = title;
    this.class = class$;
  }
}

class Choice extends $CustomType {
  constructor(title, icon, value, class$) {
    super();
    this.title = title;
    this.icon = icon;
    this.value = value;
    this.class = class$;
  }
}

export class ApplicationUpdatedChoices extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApplicationUpdatedDisabled extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApplicationUpdatedIcon extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApplicationUpdatedInputClass extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApplicationUpdatedLabel extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApplicationUpdatedPanelClass extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApplicationUpdatedPlaceholder extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApplicationUpdatedSelected extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ApplicationUpdatedPanelPosition extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class DocumentHidOverflows extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class DocumentReturnedUnsubscriber extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserClickedOutside extends $CustomType {}

export class UserEditedInput extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserInputedKey extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserSelectedChoice extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class UserSubmittedInput extends $CustomType {}

export class UserOpenedDropdown extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Model extends $CustomType {
  constructor(choices, disabled, icon, id, input, input_class, label, opened, panel_class, panel_position, placeholder, rect, selected, unsubscriber, user_edited, user_highlight) {
    super();
    this.choices = choices;
    this.disabled = disabled;
    this.icon = icon;
    this.id = id;
    this.input = input;
    this.input_class = input_class;
    this.label = label;
    this.opened = opened;
    this.panel_class = panel_class;
    this.panel_position = panel_position;
    this.placeholder = placeholder;
    this.rect = rect;
    this.selected = selected;
    this.unsubscriber = unsubscriber;
    this.user_edited = user_edited;
    this.user_highlight = user_highlight;
  }
}

export function label(text) {
  return $a.property("label", $json.string(text));
}

export function placeholder(text) {
  return $a.property("placeholder", $json.string(text));
}

export function disabled(value) {
  return $a.property("disabled", $json.bool(value));
}

export function selected(value) {
  return $a.property("selected", $json.nullable(value, $unsafe.coerce));
}

export function icon(value) {
  return $a.property("icon", $unsafe.coerce(value));
}

export function input_class(class$) {
  return $a.property("input-class", $unsafe.coerce(class$));
}

export function panel_class(class$) {
  return $a.property("panel-class", $unsafe.coerce(class$));
}

export function choice(title, value) {
  return new Choice(title, new None(), value, new $option.None());
}

export function section(title) {
  return new Section(title, new None());
}

export function no_choice() {
  return new NoChoice();
}

export function panel_right() {
  return $a.property("panel-position", $unsafe.coerce(new $position.Right()));
}

export function with_class(choice, class$) {
  if (choice instanceof NoChoice) {
    return new NoChoice();
  } else if (choice instanceof Section) {
    let title = choice.title;
    return new Section(title, new Some(class$));
  } else {
    let title = choice.title;
    let icon$1 = choice.icon;
    let value = choice.value;
    let class$1 = new $option.Some(class$);
    return new Choice(title, icon$1, value, class$1);
  }
}

export function with_icon(choice, icon) {
  if (choice instanceof NoChoice) {
    return new NoChoice();
  } else if (choice instanceof Section) {
    return choice;
  } else {
    let title = choice.title;
    let value = choice.value;
    let class$ = choice.class;
    let icon$1 = new $option.Some(icon);
    return new Choice(title, icon$1, value, class$);
  }
}

export function succeed(msg) {
  return $decode.map(
    $decode.dynamic,
    (content) => { return msg($unsafe.coerce(content)); },
  );
}

function prop(name, msg) {
  return $component.on_property_change(
    name,
    (() => {
      let _pipe = $decode.optional($decode.dynamic);
      let _pipe$1 = $decode.map(_pipe, $unsafe.coerce);
      return $decode.map(_pipe$1, msg);
    })(),
  );
}

function init(_) {
  let _pipe = new Model(
    toList([]),
    new None(),
    new None(),
    $unsafe.unique_id(),
    "",
    new None(),
    new None(),
    false,
    new None(),
    new $position.Left(),
    "Default placeholder",
    new None(),
    new None(),
    () => { return undefined; },
    false,
    new None(),
  );
  return $pair.new$(_pipe, $eff.none());
}

function is_choice(choice) {
  if (choice instanceof NoChoice) {
    return false;
  } else if (choice instanceof Section) {
    return false;
  } else {
    return true;
  }
}

function get_next_highlight(loop$choices, loop$highlight) {
  while (true) {
    let choices = loop$choices;
    let highlight = loop$highlight;
    if (choices instanceof $Empty) {
      return new Some(highlight);
    } else {
      let $ = choices.head;
      if ($ instanceof Choice) {
        let $1 = choices.tail;
        if ($1 instanceof $Empty) {
          let v1 = $.value;
          if (isEqual(v1, highlight)) {
            return new Some(highlight);
          } else {
            let rest = $1;
            loop$choices = rest;
            loop$highlight = highlight;
          }
        } else {
          let $2 = $1.head;
          if ($2 instanceof Choice) {
            let v1 = $.value;
            if (isEqual(v1, highlight)) {
              let v2 = $2.value;
              return new Some(v2);
            } else {
              let rest = $1;
              loop$choices = rest;
              loop$highlight = highlight;
            }
          } else {
            let rest = $1;
            loop$choices = rest;
            loop$highlight = highlight;
          }
        }
      } else {
        return new None();
      }
    }
  }
}

function open_dropdown(dom_rect) {
  return $eff.from(
    (dispatch) => {
      return $function.tap(
        undefined,
        (_) => {
          return $window.request_animation_frame(
            (_) => {
              let _pipe = dom_rect;
              let _pipe$1 = new DocumentHidOverflows(_pipe);
              return dispatch(_pipe$1);
            },
          );
        },
      );
    },
  );
}

function handle_user_opened_dropdown(model, dom_rect) {
  let $ = model.opened;
  if ($) {
    return [model, $eff.none()];
  } else {
    return [
      model,
      $eff.batch(
        toList([
          open_dropdown(dom_rect),
          $effects.toggle_dom_freeze(),
          $effects.subscribe_dom_click(
            (var0) => { return new DocumentReturnedUnsubscriber(var0); },
            new UserClickedOutside(),
          ),
        ]),
      ),
    ];
  }
}

function on_close(end_state) {
  return $pair.map_second(
    end_state,
    (effect) => {
      let unsub = $eff.from((_) => { return end_state[0].unsubscriber(); });
      return $eff.batch(toList([effect, unsub, $effects.stop_dom_freeze()]));
    },
  );
}

function get_choice_value(choice) {
  if (choice instanceof NoChoice) {
    return new None();
  } else if (choice instanceof Section) {
    return new None();
  } else {
    let value = choice.value;
    return new Some(value);
  }
}

function get_user_next_highlight(model, choices) {
  let _block;
  let _record = model;
  _block = new Model(
    _record.choices,
    _record.disabled,
    _record.icon,
    _record.id,
    _record.input,
    _record.input_class,
    _record.label,
    _record.opened,
    _record.panel_class,
    _record.panel_position,
    _record.placeholder,
    _record.rect,
    _record.selected,
    _record.unsubscriber,
    _record.user_edited,
    (() => {
      let $ = model.user_highlight;
      if ($ instanceof Some) {
        let highlight = $[0];
        return get_next_highlight(choices, highlight);
      } else {
        let _pipe = $list.first(choices);
        let _pipe$1 = $option.from_result(_pipe);
        return $option.then$(_pipe$1, get_choice_value);
      }
    })(),
  );
  let _pipe = _block;
  return $pair.new$(_pipe, $eff.none());
}

function get_choice_icon(choice) {
  if (choice instanceof NoChoice) {
    return new None();
  } else if (choice instanceof Section) {
    return new None();
  } else {
    let icon$1 = choice.icon;
    return icon$1;
  }
}

function get_choice_title(choice) {
  if (choice instanceof NoChoice) {
    return new None();
  } else if (choice instanceof Section) {
    return new None();
  } else {
    let title = choice.title;
    return new Some(title);
  }
}

function get_choice(model, value) {
  let _pipe = model.choices;
  let _pipe$1 = $list.find(
    _pipe,
    (c) => { return isEqual(get_choice_value(c), value); },
  );
  return $option.from_result(_pipe$1);
}

function select_input(model) {
  let _record = model;
  return new Model(
    _record.choices,
    _record.disabled,
    _record.icon,
    _record.id,
    (() => {
      let _pipe = get_choice(model, model.selected);
      let _pipe$1 = $option.then$(_pipe, get_choice_title);
      return $option.unwrap(_pipe$1, "");
    })(),
    _record.input_class,
    _record.label,
    _record.opened,
    _record.panel_class,
    _record.panel_position,
    _record.placeholder,
    _record.rect,
    _record.selected,
    _record.unsubscriber,
    _record.user_edited,
    _record.user_highlight,
  );
}

function handle_user_clicked_outside(model) {
  let _block;
  let _record = model;
  _block = new Model(
    _record.choices,
    _record.disabled,
    _record.icon,
    _record.id,
    _record.input,
    _record.input_class,
    _record.label,
    false,
    _record.panel_class,
    _record.panel_position,
    _record.placeholder,
    _record.rect,
    _record.selected,
    _record.unsubscriber,
    false,
    new None(),
  );
  let model_ = _block;
  let $ = model.opened;
  if ($) {
    let _pipe = [select_input(model_), $eff.none()];
    return on_close(_pipe);
  } else {
    return [model_, $eff.none()];
  }
}

function handle_user_selected_choice(model, value) {
  let _block;
  let _record = model;
  _block = new Model(
    _record.choices,
    _record.disabled,
    _record.icon,
    _record.id,
    _record.input,
    _record.input_class,
    _record.label,
    false,
    _record.panel_class,
    _record.panel_position,
    _record.placeholder,
    _record.rect,
    _record.selected,
    _record.unsubscriber,
    false,
    new None(),
  );
  let model$1 = _block;
  let _block$1;
  let $ = get_choice(model$1, new Some(value));
  if ($ instanceof Some) {
    let choice$1 = $[0];
    let $1 = get_choice_value(choice$1);
    if (!($1 instanceof Some)) {
      throw makeError(
        "let_assert",
        FILEPATH,
        "ds/components/combobox",
        426,
        "handle_user_selected_choice",
        "Pattern match failed, no pattern matched the value.",
        {
          value: $1,
          start: 11410,
          end: 11459,
          pattern_start: 11421,
          pattern_end: 11432
        }
      )
    }
    let value$1 = $1[0];
    let _block$2;
    let $2 = model$1.selected;
    if ($2 instanceof Some) {
      let selected$1 = $2[0];
      if (isEqual(selected$1, value$1)) {
        let $3 = get_choice_title(choice$1);
        if (!($3 instanceof Some)) {
          throw makeError(
            "let_assert",
            FILEPATH,
            "ds/components/combobox",
            430,
            "handle_user_selected_choice",
            "Pattern match failed, no pattern matched the value.",
            {
              value: $3,
              start: 11581,
              end: 11630,
              pattern_start: 11592,
              pattern_end: 11603
            }
          )
        }
        let title = $3[0];
        let _record$1 = model$1;
        _block$2 = new Model(
          _record$1.choices,
          _record$1.disabled,
          _record$1.icon,
          _record$1.id,
          title,
          _record$1.input_class,
          _record$1.label,
          _record$1.opened,
          _record$1.panel_class,
          _record$1.panel_position,
          _record$1.placeholder,
          _record$1.rect,
          _record$1.selected,
          _record$1.unsubscriber,
          _record$1.user_edited,
          _record$1.user_highlight,
        );
      } else {
        _block$2 = model$1;
      }
    } else {
      _block$2 = model$1;
    }
    let model$2 = _block$2;
    let effect = $e.emit("selected", $unsafe.coerce(value$1));
    _block$1 = [model$2, effect];
  } else {
    _block$1 = [
      (() => {
        let _record$1 = model$1;
        return new Model(
          _record$1.choices,
          _record$1.disabled,
          _record$1.icon,
          _record$1.id,
          _record$1.input,
          _record$1.input_class,
          _record$1.label,
          _record$1.opened,
          _record$1.panel_class,
          _record$1.panel_position,
          _record$1.placeholder,
          _record$1.rect,
          new None(),
          _record$1.unsubscriber,
          _record$1.user_edited,
          _record$1.user_highlight,
        );
      })(),
      $eff.none(),
    ];
  }
  let _pipe = _block$1;
  return on_close(_pipe);
}

function on_toggle(disabled) {
  return $bool.lazy_guard(
    disabled,
    $a.none,
    () => {
      let _pipe = $e.on(
        "click",
        $decode.then$(
          $decode.dynamic,
          (event) => {
            let $ = $position.get_event_bounding_client_rect(event);
            if ($ instanceof Ok) {
              let domrect = $[0];
              return $decode.success(new UserOpenedDropdown(domrect));
            } else {
              return $decode.failure(
                new UserClickedOutside(),
                "BoundingClientRect",
              );
            }
          },
        ),
      );
      return $e.stop_propagation(_pipe);
    },
  );
}

function view_dropdown_icon(model, content) {
  let _pipe = content;
  let _pipe$1 = $option.then$(_pipe, get_choice_icon);
  let _pipe$2 = $option.or(_pipe$1, model.icon);
  let _pipe$3 = $option.map(_pipe$2, $s.full_icon_wrapper);
  return $option.lazy_unwrap(_pipe$3, $el.none);
}

function keep_matching_title(choice, model) {
  if (choice instanceof NoChoice) {
    return false;
  } else if (choice instanceof Section) {
    return true;
  } else {
    let title = choice.title;
    let title$1 = $string.lowercase(title);
    let input = $string.lowercase(model.input);
    return $string.contains(title$1, input);
  }
}

function remove_empty_sections(loop$choices, loop$return) {
  while (true) {
    let choices = loop$choices;
    let return$ = loop$return;
    if (choices instanceof $Empty) {
      return return$;
    } else {
      let $ = choices.tail;
      if ($ instanceof $Empty) {
        let $1 = choices.head;
        if ($1 instanceof Section) {
          return return$;
        } else {
          let fst = $1;
          let rest = $;
          loop$choices = rest;
          loop$return = listPrepend(fst, return$);
        }
      } else {
        let $1 = $.head;
        if ($1 instanceof Section) {
          let $2 = choices.head;
          if ($2 instanceof Section) {
            let fst = $1;
            let rest = $.tail;
            loop$choices = listPrepend(fst, rest);
            loop$return = return$;
          } else {
            let fst = $2;
            let rest = $;
            loop$choices = rest;
            loop$return = listPrepend(fst, return$);
          }
        } else {
          let fst = choices.head;
          let rest = $;
          loop$choices = rest;
          loop$return = listPrepend(fst, return$);
        }
      }
    }
  }
}

function filter_choices(model) {
  let no_filter = $string.is_empty(model.input);
  let default_display = !model.user_edited;
  return $bool.guard(
    no_filter || default_display,
    model.choices,
    () => {
      let _pipe = $list.filter(
        model.choices,
        (_capture) => { return keep_matching_title(_capture, model); },
      );
      let _pipe$1 = remove_empty_sections(_pipe, toList([]));
      return $list.reverse(_pipe$1);
    },
  );
}

function update(model, msg) {
  if (msg instanceof ApplicationUpdatedChoices) {
    let choices = msg[0];
    let _block;
    let _record = model;
    _block = new Model(
      choices,
      _record.disabled,
      _record.icon,
      _record.id,
      _record.input,
      _record.input_class,
      _record.label,
      _record.opened,
      _record.panel_class,
      _record.panel_position,
      _record.placeholder,
      _record.rect,
      _record.selected,
      _record.unsubscriber,
      _record.user_edited,
      _record.user_highlight,
    );
    let model$1 = _block;
    return [model$1, $eff.none()];
  } else if (msg instanceof ApplicationUpdatedDisabled) {
    let content = msg[0];
    let _block;
    let _record = model;
    _block = new Model(
      _record.choices,
      content,
      _record.icon,
      _record.id,
      _record.input,
      _record.input_class,
      _record.label,
      _record.opened,
      _record.panel_class,
      _record.panel_position,
      _record.placeholder,
      _record.rect,
      _record.selected,
      _record.unsubscriber,
      _record.user_edited,
      _record.user_highlight,
    );
    let model$1 = _block;
    return [model$1, $eff.none()];
  } else if (msg instanceof ApplicationUpdatedIcon) {
    let content = msg[0];
    let _block;
    let _record = model;
    _block = new Model(
      _record.choices,
      _record.disabled,
      content,
      _record.id,
      _record.input,
      _record.input_class,
      _record.label,
      _record.opened,
      _record.panel_class,
      _record.panel_position,
      _record.placeholder,
      _record.rect,
      _record.selected,
      _record.unsubscriber,
      _record.user_edited,
      _record.user_highlight,
    );
    let model$1 = _block;
    return [model$1, $eff.none()];
  } else if (msg instanceof ApplicationUpdatedInputClass) {
    let input_class$1 = msg[0];
    let _block;
    let _record = model;
    _block = new Model(
      _record.choices,
      _record.disabled,
      _record.icon,
      _record.id,
      _record.input,
      input_class$1,
      _record.label,
      _record.opened,
      _record.panel_class,
      _record.panel_position,
      _record.placeholder,
      _record.rect,
      _record.selected,
      _record.unsubscriber,
      _record.user_edited,
      _record.user_highlight,
    );
    let model$1 = _block;
    return [model$1, $eff.none()];
  } else if (msg instanceof ApplicationUpdatedLabel) {
    let content = msg[0];
    let _block;
    let _record = model;
    _block = new Model(
      _record.choices,
      _record.disabled,
      _record.icon,
      _record.id,
      _record.input,
      _record.input_class,
      content,
      _record.opened,
      _record.panel_class,
      _record.panel_position,
      _record.placeholder,
      _record.rect,
      _record.selected,
      _record.unsubscriber,
      _record.user_edited,
      _record.user_highlight,
    );
    let model$1 = _block;
    return [model$1, $eff.none()];
  } else if (msg instanceof ApplicationUpdatedPanelClass) {
    let panel_class$1 = msg[0];
    let _block;
    let _record = model;
    _block = new Model(
      _record.choices,
      _record.disabled,
      _record.icon,
      _record.id,
      _record.input,
      _record.input_class,
      _record.label,
      _record.opened,
      panel_class$1,
      _record.panel_position,
      _record.placeholder,
      _record.rect,
      _record.selected,
      _record.unsubscriber,
      _record.user_edited,
      _record.user_highlight,
    );
    let model$1 = _block;
    return [model$1, $eff.none()];
  } else if (msg instanceof ApplicationUpdatedPlaceholder) {
    let placeholder$1 = msg[0];
    let _block;
    let _record = model;
    _block = new Model(
      _record.choices,
      _record.disabled,
      _record.icon,
      _record.id,
      _record.input,
      _record.input_class,
      _record.label,
      _record.opened,
      _record.panel_class,
      _record.panel_position,
      placeholder$1,
      _record.rect,
      _record.selected,
      _record.unsubscriber,
      _record.user_edited,
      _record.user_highlight,
    );
    let model$1 = _block;
    return [model$1, $eff.none()];
  } else if (msg instanceof ApplicationUpdatedSelected) {
    let selected$1 = msg[0];
    let _block;
    let _record = model;
    _block = new Model(
      _record.choices,
      _record.disabled,
      _record.icon,
      _record.id,
      _record.input,
      _record.input_class,
      _record.label,
      _record.opened,
      _record.panel_class,
      _record.panel_position,
      _record.placeholder,
      _record.rect,
      selected$1,
      _record.unsubscriber,
      _record.user_edited,
      _record.user_highlight,
    );
    let model$1 = _block;
    let model$2 = select_input(model$1);
    return [model$2, $eff.none()];
  } else if (msg instanceof ApplicationUpdatedPanelPosition) {
    let panel_position = msg[0];
    let panel_position$1 = $option.unwrap(panel_position, new $position.Left());
    let _block;
    let _record = model;
    _block = new Model(
      _record.choices,
      _record.disabled,
      _record.icon,
      _record.id,
      _record.input,
      _record.input_class,
      _record.label,
      _record.opened,
      _record.panel_class,
      panel_position$1,
      _record.placeholder,
      _record.rect,
      _record.selected,
      _record.unsubscriber,
      _record.user_edited,
      _record.user_highlight,
    );
    let model$1 = _block;
    return [model$1, $eff.none()];
  } else if (msg instanceof DocumentHidOverflows) {
    let rect = msg[0];
    let rect$1 = new Some(rect);
    let _block;
    let _record = model;
    _block = new Model(
      _record.choices,
      _record.disabled,
      _record.icon,
      _record.id,
      _record.input,
      _record.input_class,
      _record.label,
      true,
      _record.panel_class,
      _record.panel_position,
      _record.placeholder,
      rect$1,
      _record.selected,
      _record.unsubscriber,
      _record.user_edited,
      _record.user_highlight,
    );
    let model$1 = _block;
    return [model$1, $eff.none()];
  } else if (msg instanceof DocumentReturnedUnsubscriber) {
    let unsubscriber = msg[0];
    let _block;
    let _record = model;
    _block = new Model(
      _record.choices,
      _record.disabled,
      _record.icon,
      _record.id,
      _record.input,
      _record.input_class,
      _record.label,
      _record.opened,
      _record.panel_class,
      _record.panel_position,
      _record.placeholder,
      _record.rect,
      _record.selected,
      unsubscriber,
      _record.user_edited,
      _record.user_highlight,
    );
    let model$1 = _block;
    return [model$1, $eff.none()];
  } else if (msg instanceof UserClickedOutside) {
    return handle_user_clicked_outside(model);
  } else if (msg instanceof UserEditedInput) {
    let input = msg[0];
    return $bool.guard(
      !model.opened,
      [model, $eff.none()],
      () => {
        let _block;
        let _record = model;
        _block = new Model(
          _record.choices,
          _record.disabled,
          _record.icon,
          _record.id,
          input,
          _record.input_class,
          _record.label,
          _record.opened,
          _record.panel_class,
          _record.panel_position,
          _record.placeholder,
          _record.rect,
          _record.selected,
          _record.unsubscriber,
          true,
          new None(),
        );
        let model$1 = _block;
        return [model$1, $eff.none()];
      },
    );
  } else if (msg instanceof UserInputedKey) {
    let event = msg[0][0];
    let key = msg[0][1];
    let is_arrow = ((key === "ArrowUp") || (key === "ArrowDown")) || (key === "Enter");
    return $bool.guard(
      !is_arrow,
      [model, $eff.none()],
      () => {
        $input.prevent_default(event);
        let _block;
        let _pipe = filter_choices(model);
        _block = $list.filter(_pipe, is_choice);
        let choices = _block;
        if (key === "ArrowDown") {
          return get_user_next_highlight(model, choices);
        } else if (key === "ArrowUp") {
          return get_user_next_highlight(model, $list.reverse(choices));
        } else if (key === "Enter") {
          let $ = model.user_highlight;
          if ($ instanceof Some) {
            let value = $[0];
            $input.blur_target(event);
            return handle_user_selected_choice(model, value);
          } else {
            return [model, $eff.none()];
          }
        } else {
          throw makeError(
            "panic",
            FILEPATH,
            "ds/components/combobox",
            336,
            "update",
            "Unreachable clause.",
            {}
          )
        }
      },
    );
  } else if (msg instanceof UserSelectedChoice) {
    let value = msg[0];
    return handle_user_selected_choice(model, value);
  } else if (msg instanceof UserSubmittedInput) {
    let $ = model.user_highlight;
    if ($ instanceof Some) {
      let value = $[0];
      return handle_user_selected_choice(model, value);
    } else {
      return [model, $eff.none()];
    }
  } else {
    let dom_rect = msg[0];
    return handle_user_opened_dropdown(model, dom_rect);
  }
}

function portal_style(model, rect) {
  return $css.class$(
    toList([
      (() => {
        let _pipe = model.panel_class;
        let _pipe$1 = $option.map(_pipe, $css.compose);
        return $option.lazy_unwrap(_pipe$1, $css.none);
      })(),
      $css.position("fixed"),
      $css.width($length.px_(rect.right - rect.left)),
      $position.compute_horizontal_position(rect, model.panel_position),
      $position.compute_vertical_position(rect),
    ]),
  );
}

function view_section(option) {
  if (!(option instanceof Section)) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "ds/components/combobox",
      610,
      "view_section",
      "Pattern match failed, no pattern matched the value.",
      {
        value: option,
        start: 16748,
        end: 16791,
        pattern_start: 16759,
        pattern_end: 16782
      }
    )
  }
  let title = option.title;
  let class$ = option.class;
  return $s.section_wrapper(class$, toList([]), toList([$h.text(title)]));
}

function view_icon(icon) {
  let _pipe = icon;
  let _pipe$1 = $option.map(_pipe, $s.full_icon_wrapper);
  return $option.lazy_unwrap(_pipe$1, $el.none);
}

function view_choice(current_value, option, highlighted) {
  if (!(option instanceof Choice)) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "ds/components/combobox",
      615,
      "view_choice",
      "Pattern match failed, no pattern matched the value.",
      {
        value: option,
        start: 16926,
        end: 16983,
        pattern_start: 16937,
        pattern_end: 16974
      }
    )
  }
  let title = option.title;
  let icon$1 = option.icon;
  let value = option.value;
  let class$ = option.class;
  let on_click = $e.on_click(new UserSelectedChoice(value));
  let cy = $cy.data($justin.kebab_case(title) + "-choice");
  return $s.choice_wrapper(
    class$,
    highlighted,
    toList([on_click, cy]),
    toList([
      $s.choice_icon_wrapper(
        toList([]),
        toList([view_icon(icon$1), $h.text(title)]),
      ),
      (() => {
        let $ = isEqual(current_value, new Some(value));
        if ($) {
          return $s.icon_wrapper(toList([]), toList([$icons.checkmark()]));
        } else {
          return $el.none();
        }
      })(),
    ]),
  );
}

function view_dropdown_modal(model, rect, value) {
  let style = portal_style(model, rect);
  return $portal.portal(
    model.id,
    (() => {
      let choices = filter_choices(model);
      return $s.children_wrapper(
        style,
        toList([$utils.stop_propagation()]),
        (() => {
          let $ = $list.is_empty(choices);
          if ($) {
            return toList([
              $s.no_choice(toList([]), toList([$el.text("No matching choice")])),
            ]);
          } else {
            return $list.filter_map(
              choices,
              (option) => {
                if (option instanceof NoChoice) {
                  return new Error(undefined);
                } else if (option instanceof Section) {
                  return new Ok(view_section(option));
                } else {
                  let v = option.value;
                  let highlighted = isEqual(new Some(v), model.user_highlight);
                  return new Ok(view_choice(value, option, highlighted));
                }
              },
            );
          }
        })(),
      );
    })(),
  );
}

function view_content(model) {
  let content = get_choice(model, model.selected);
  let value = $option.then$(content, get_choice_value);
  return $s.full_wrapper(
    toList([]),
    toList([
      $input.input(
        toList([
          $input.placeholder(model.placeholder),
          $input.icon(view_dropdown_icon(model, content)),
          $input.value(model.input),
          $input.on_input((var0) => { return new UserEditedInput(var0); }),
          $input.on_keydown((var0) => { return new UserInputedKey(var0); }),
          $input.enter_submit(),
          $input.on_submit(new UserSubmittedInput()),
          (() => {
            let $ = model.disabled;
            if ($ instanceof Some) {
              let disabled$1 = $[0];
              return $input.disabled(disabled$1);
            } else {
              return $input.disabled(false);
            }
          })(),
        ]),
      ),
      (() => {
        let $ = model.opened;
        let $1 = model.rect;
        if ($) {
          if ($1 instanceof Some) {
            let rect = $1[0];
            return view_dropdown_modal(model, rect, value);
          } else {
            return $el.none();
          }
        } else {
          return $el.none();
        }
      })(),
    ]),
  );
}

function view(model, stylesheet, container) {
  return $sl.render(
    stylesheet,
    toList([container, $sl.node()]),
    () => {
      let id = $a.id("domrect-" + $int.to_string(model.id));
      let rect_class = $a.class$($position.wrapper_class);
      let disabled$1 = $option.unwrap(model.disabled, false);
      let on_toggle$1 = on_toggle(disabled$1);
      return $s.wrapper(
        disabled$1,
        toList([id, rect_class, on_toggle$1]),
        (() => {
          let $ = model.label;
          if ($ instanceof Some) {
            let label$1 = $[0];
            return toList([$html.text(label$1), view_content(model)]);
          } else {
            return toList([view_content(model)]);
          }
        })(),
      );
    },
  );
}

const tag_name = "steerlab-combobox";

export function combobox(on, attrs, options) {
  let options$1 = $a.property("choices", $unsafe.coerce(options));
  let on_selected = $e.on(
    "selected",
    $decode.field(
      "detail",
      $decode.dynamic,
      (content) => {
        let content$1 = $unsafe.coerce(content);
        return $decode.success(on(content$1));
      },
    ),
  );
  return $el.element(
    tag_name,
    listPrepend(options$1, listPrepend(on_selected, attrs)),
    toList([]),
  );
}

export function register(stylesheet, container) {
  let view$1 = (_capture) => { return view(_capture, stylesheet, container); };
  let _pipe = $lustre.component(
    init,
    update,
    view$1,
    toList([
      $component.adopt_styles(true),
      $component.on_property_change(
        "choices",
        (() => {
          let _pipe = $decode.list($decode.dynamic);
          let _pipe$1 = $decode.map(_pipe, $unsafe.coerce);
          return $decode.map(
            _pipe$1,
            (var0) => { return new ApplicationUpdatedChoices(var0); },
          );
        })(),
      ),
      $component.on_property_change(
        "label",
        (() => {
          let _pipe = $decode.optional($decode.string);
          return $decode.map(
            _pipe,
            (var0) => { return new ApplicationUpdatedLabel(var0); },
          );
        })(),
      ),
      $component.on_property_change(
        "placeholder",
        (() => {
          let _pipe = $decode.string;
          return $decode.map(
            _pipe,
            (var0) => { return new ApplicationUpdatedPlaceholder(var0); },
          );
        })(),
      ),
      $component.on_property_change(
        "disabled",
        (() => {
          let _pipe = $decode.optional($decode.bool);
          return $decode.map(
            _pipe,
            (var0) => { return new ApplicationUpdatedDisabled(var0); },
          );
        })(),
      ),
      prop(
        "panel-position",
        (var0) => { return new ApplicationUpdatedPanelPosition(var0); },
      ),
      prop(
        "selected",
        (var0) => { return new ApplicationUpdatedSelected(var0); },
      ),
      prop("icon", (var0) => { return new ApplicationUpdatedIcon(var0); }),
      prop(
        "panel-class",
        (var0) => { return new ApplicationUpdatedPanelClass(var0); },
      ),
      prop(
        "input-class",
        (var0) => { return new ApplicationUpdatedInputClass(var0); },
      ),
    ]),
  );
  return $lustre.register(_pipe, tag_name);
}
